var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "stage" }, [
    _c("img", {
      staticClass: "stage__room",
      style: _vm.roomStyle,
      attrs: { src: _vm.roomSrc, alt: "" },
    }),
    _c(
      "div",
      { staticClass: "stage__cat", style: _vm.catStyle },
      [
        _c("assistant-cat-home-idle-cat", {
          attrs: { "writer-type": _vm.writerType, "cat-name": _vm.catName },
          on: {
            "tap-burst": function ($event) {
              return _vm.$emit("tap-burst", $event)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }